export const defaultLanguage = "nl";
const data = {
  snackbar: {
    nl: "Dit dossier komt het best tot zijn recht op een desktop computer",
    en: "These files can be viewed best on a desktop computer",
  },
  start_title: {
    nl: 'Het strafdossier <span class="hilite">MH17</span>',
    en: 'The <span class="hilite">MH17</span> criminal files',
  },
  start_content: {
    nl: "<p>17 juli 2014, een warme zomerdag. Vanaf de luchthaven Schiphol vertrekken 283 passagiers en 15 bemanningsleden met vlucht MH17 van Malaysia Airlines naar Kuala Lumpur, Maleisië. </p> <p> Die vlucht duurt nog geen drie uur als de luchtverkeersleiding in Oost-Oekraïne om 13:20 uur UTC (16:20 uur lokale Oekraïense tijd), het contact met MH17 verliest. Op dat moment detoneert een warhead van een Buk-raket linksboven de cockpit. Fragmentatie- en raketdelen doorboren de linkerzijde van de cockpit en de daarbij vrijkomende drukgolf doet de rest; de romp van het vliegtuig breekt in meerdere delen en valt naar beneden. Alle 298 inzittenden komen om het leven. Dat het hier gaat om een Buk-raket afgeschoten vanuit een landbouwveld nabij Pervomaiskyi in Oost-Oekraïne blijkt later uit onderzoek van het Joint Investigation Team, waarin Nederland samenwerkt met Australië, Maleisië, Oekraïne en België.</p>",
    en: "<p>17 July 2014 is a warm summer’s day. At Schiphol Airport in Amsterdam, Malaysia Airlines flight MH17 departs for Kuala Lumpur, Malaysia, with 283 passengers and 15 crew members. </p> <p> The flight has been under way for less than three hours when, at 13:20 UTC (16:20 local time) air traffic control in eastern Ukraine loses contact with MH17. At that instant a Buk missile warhead detonates over the top left side of the cockpit. Fragments and missile parts penetrate the left side of the cockpit, and the resulting pressure wave does the rest: the aircraft’s fuselage breaks into several pieces and falls to the ground. All 298 persons on board are killed. It later emerges from the investigation conducted by the Joint Investigation Team – a partnership between the Netherlands, Australia, Malaysia, Ukraine and Belgium – that the cause of the disaster was a Buk missile fired from an agricultural field near Pervomaiskyi in eastern Ukraine.</p>",
  },
  start_button: {
    nl: "begin het verhaal",
    en: "to the beginning",
  },
  start_accountability: {
    nl: '<p>Tijdens het strafproces heeft de rechtbank het volledige dossier samengevat en besproken. Daarbij zijn niet alle besproken bewijzen getoond of afgespeeld. Die bespreking van de rechtbank is terug te vinden op <a target="_blank" href="https://www.courtmh17.com" >www.courtmh17.com</a >. Het dossier is omvangrijk en ook deze daaruit afgeleide publicatie van het Openbaar Ministerie is niet volledig. Deze publicatie van het Openbaar Ministerie biedt nabestaanden en het bredere publiek nadere en toegankelijke informatie uit het dossier. Een overzicht van alle zittingsdagen en de teksten van het Openbaar Ministerie is terug te vinden op <a target="_blank" href="https://www.om.nl/mh17">www.om.nl/mh17</a>.</p>',
    en: '<p>During these criminal proceedings the court summarised and discussed the entire case file. Not all the evidence that was discussed was exhibited or played at trial. The court’s discussion can be found at <a target="_blank" href="https://www.courtmh17.com" >www.courtmh17.com</a>. The case file is extensive and this publication is not intended to be an exhaustive guide. This summary by the Public Prosecution Service is intended to offer the next of kin and the wider public detailed and accessible information from the case file. An overview of all court hearings and associated texts can be found at <a target="_blank" href="https://www.prosecutionservice.nl/mh17">www.prosecutionservice.nl/mh17</a>.</p>',
  },
  intro_title: {
    nl: "Introductie",
    en: "Introduction",
  },
  intro_content: {
    nl: "In deze publicatie kunt u lezen, horen en zien welke bewijzen er onder meer in het strafdossier zitten. Aan de hand van een interactieve kaart kunt u zien wat er zich voor, tijdens en na het neerhalen van vlucht MH17 afspeelde. Wat zegt het onderzoek over de feitelijke toedracht en de betrokkenheid van de verdachten? Lees het verhaal vanaf het begin door hier te klikken of kies een specifiek deel.",
    en: "In this publication you can read, hear and see what evidence there is, among other, in the casefile. By navigating on an interactive map you can see what took place before, during and after the downing of flight MH17. What does the investigation say about the facts and the involvement of the defendants? Read the story from the beginning by clicking here or choose a specific part.",
  },
  intro_button: {
    nl: "naar het begin",
    en: "to the beginning",
  },
  return_to_overview: {
    nl: "terug naar het overzicht",
    en: "return to overview",
  },
  click_to_open: {
    nl: "Klik om te openen",
    en: "Click to open",
  },
  events: {
    nl: "Gebeurtenissen",
    en: "Events",
  },
  search_title: {
    nl: "Filtering",
    en: "Filtering",
  },
  search_clear_filters: {
    nl: "Wis filters",
    en: "Clear filters",
  },
  search_show: {
    nl: "Toon",
    en: "Show",
  },
  search_show_results: {
    nl: "Toon gevonden resultaten",
    en: "Show results",
  },
  search_found_result: {
    nl: "gevonden resultaat",
    en: "found result",
  },
  search_found_results: {
    nl: "gevonden resultaten",
    en: "found results",
  },
  index_part_title: {
    nl: "Deel",
    en: "Part",
  },
  index_chapter_title: {
    nl: "Hoofdstuk",
    en: "Chapter",
  },
  index_button: {
    nl: "Naar deel ",
    en: "To part ",
  },
  story_part_title: {
    nl: "Deel",
    en: "Part",
  },
  story_chapter_title: {
    nl: "Hoofdstuk",
    en: "Chapter",
  },
  encore_next_part: {
    nl: "Naar volgend deel",
    en: "To the next part",
  },
  encore_previous_part: {
    nl: "Naar vorig deel",
    en: "To the previous part",
  },
  forensic_investigation: {
    nl: "Forensisch onderzoek",
    en: "Forensic investigation",
  },
  impact_damage_aircraft: {
    nl: '<input type="checkbox" value=".schadebeeld-vliegtuig" /><span></span> Schadebeeld vliegtuig',
    en: '<input type="checkbox" value=".impact-damage-aircraft" /><span></span> Impact damage aircraft',
  },
  weapon: {
    nl: '<input type="checkbox" value=".wapen" /> <span></span> Wapen',
    en: '<input type="checkbox" value=".weapon" /> <span></span> Weapon',
  },
  bodies: {
    nl: '<input type="checkbox" value=".lichamen" /> <span></span> Lichamen',
    en: '<input type="checkbox" value=".bodies" /> <span></span> Bodies',
  },
  soil_samples_investigation: {
    nl: '<input type="checkbox" value=".bodemonderzoek" /> <span></span> Bodemonderzoek',
    en: '<input type="checkbox" value=".soil-samples-investigation" /> <span></span> Soil samples investigation',
  },
  telecommunication: {
    nl: "Telecommunicatie",
    en: "Telecommunication",
  },
  tapped_conversations: {
    nl: '<input type="checkbox" value=".tapgesprekken" /> <span></span> Tapgesprekken',
    en: '<input type="checkbox" value=".tapped-conversations" /> <span></span> Tapped conversations',
  },
  defendants: {
    nl: "Verdachten",
    en: "Defendants",
  },
  witnesses: {
    nl: "Getuigen",
    en: "Witnesses",
  },
  other_witnesses: {
    nl: '<input type="checkbox" value=".tapgesprekken" /> <span></span> Overige getuigen',
    en: '<input type="checkbox" value=".other-witnesses" /> <span></span> Other witnesses',
  },
  pictures: {
    nl: '<input type="checkbox" value=".tapgesprekken" /> <span></span> Afbeeldingen',
    en: '<input type="checkbox" value=".pictures" /> <span></span> Pictures',
  },
  experts: {
    nl: "Deskundigen",
    en: "Experts",
  },
  ministry_of_denfense: {
    nl: '<input type="checkbox" value=".ministerie-van-defensie" /> <span></span> Ministerie van Defensie',
    en: '<input type="checkbox" value=".ministry-of-denfense" /> <span></span> Ministry of Denfense',
  },
};

export const t = (key) => {
  if (!data[key] && process.env.DEBUG) {
    console.log("missing translation");
  } else {
    if (process.env?.LANGUAGE === "") {
      return data[key][defaultLanguage];
    } else {
      return data[key][process.env.LANGUAGE];
    }
  }
};
